module.exports = __webpack_public_path__ + "static/media/woman-dancing.fd440469.png";